var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBeta = function SvgLogoBeta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.273 23.25 18 4 5 11v14.583L16.227 32v-3.5l-2.954-5.25Z",
    fill: "#6F469A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.727 23.25 18 4l13 7v14.583L19.772 32v-3.5l2.955-5.25Z",
    fill: "#DC6803"
  })));
};
export default SvgLogoBeta;